<div class="text" *ngIf="data.content"  [style]="{'background-color': data.backgroundColor, '--text-color': data.textColor}">
  <div class="container  p-md-0">
    <div class="row px-2 p-md-0">
      <div class="col-12 offset-md-2 col-md-8">
        <div  [innerHTML]="transformYourHtml(data.content)"></div>
      </div>
    </div>
  </div>
</div>
